module.exports = __webpack_public_path__ + "img/search-page.c7c279a8.jpg";